// extracted by mini-css-extract-plugin
export default {"welcome-section":"WelcomeSection_welcome-section__jeO71","welcome-section-container":"WelcomeSection_welcome-section-container__TDaTG","plant":"WelcomeSection_plant__pTmLE"};